import { render, staticRenderFns } from "./C2R.vue?vue&type=template&id=187eb0dd&scoped=true"
import script from "./C2R.vue?vue&type=script&lang=js"
export * from "./C2R.vue?vue&type=script&lang=js"
import style0 from "./C2R.vue?vue&type=style&index=0&id=187eb0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187eb0dd",
  null
  
)

export default component.exports